import axios from 'axios'

const errorHandle = (status, msg) => {
	switch (status) {
		case 400:
			console.log(status)
			break;
		case 404:
			console.log(status)
			break;			
		case 500:
			tip('API出事惹QAQ')
			break;

		default:
			console.log('攔不到錯誤QQ')
	}
}

var instance = axios.create({
	baseURL: process.env.VUE_APP_API_ENDPOINT,
    responseType: 'blob',
})

instance.interceptors.request.use(
	(config) => {
		let admin_session = localStorage.getItem('admin_session')
		let token = 'Bearer reservation_admin.reservation_admin1805'
		if (admin_session !== null){
			admin_session = JSON.parse(admin_session)
			token += '.' + admin_session.user_id + '.' + admin_session.token
			config.headers.Authorization = token;
		}
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

instance.interceptors.response.use(
	(response) => {
		return response;
	},
	(error) => {
		const { response } = error;

		if (response) {
			errorHandle(response.status, response.data.error);
		}

		return Promise.reject(error);
	}
);

export default function(method, url, data=null) {
	method = method.toLowerCase();

	switch (method) {
		case 'get':
			return instance.get(url, {params: data})

		case 'post':
			return instance.post(url, data)

		case 'put':
			return instance.put(url, data)

		case 'delete':
			return instance.delete(url, {params: data})

		default:
			console.error('unknown_request_method' + method)
			return false
	}
}
